export default {
    FETCHED_ALL_DASHBOARD_DATA: 'FETCHED_ALL_DASHBOARD_DATA',
    FETCHED_ALL_DASHBOARD_DATA_LOADING: 'FETCHED_ALL_DASHBOARD_DATA_LOADING',
    FETCHED_ALL_DASHBOARD_DATA_ERROR: 'FETCHED_ALL_DASHBOARD_DATA_ERROR',
    FETCHED_MERCHANT_BUYERPLATFORM_REPORT: 'FETCHED_MERCHANT_BUYERPLATFORM_REPORT',
    GET_CURRENCY_LIST: "GET_CURRENCY_LIST"
}